import { Link } from 'react-router';

function NotFoundPage() {
  return (
    <div className="axi-gallery">
      <header className="axi-gallery__topbar">
        <div className="axi-gallery__brand">
          <span className="axi-gallery__brand-mark" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="12,3 21,12 12,21 3,12" />
            </svg>
          </span>
          <span>Axi Design</span>
        </div>
      </header>
      <main className="axi-gallery__main">
        <h1 className="axi-gallery__title">404 · 找不到该路径</h1>
        <p className="axi-gallery__sub">
          设计系统画廊:
          <Link to="/"> /</Link> ·
          <Link to="/examples/tokens"> /examples/tokens</Link> ·
          <Link to="/examples/themes"> /examples/themes</Link> ·
          <Link to="/examples/components"> /examples/components</Link> ·
          <Link to="/examples/dashboard"> /examples/dashboard</Link>(EXCEL HR 工作台)
        </p>
        <p className="axi-gallery__sub">
          业务页面:
          <Link to="/app/dashboard"> 工作台</Link> ·
          <Link to="/app/people"> 员工管理</Link> ·
          <Link to="/app/attendance"> 考勤管理</Link> ·
          <Link to="/app/payroll"> 薪酬管理</Link> ·
          <Link to="/app/recruit"> 招聘管理</Link> ·
          <Link to="/app/approval"> 审批管理</Link> ·
          <Link to="/app/analytics"> 数据分析</Link> ·
          <Link to="/app/settings"> 系统设置</Link>
        </p>
      </main>
    </div>
  );
}

export default NotFoundPage;